export default function progress() {
  const progress = document.querySelector('#progress');
  if (!progress) {
    console.warn('No #progress element found');
    return;
  }

  const onScroll = () => {
    const postContentEnd = document.querySelector('#post-content-end');
    if (!postContentEnd) {
      console.warn('#post-content-end not found');
      return;
    }
    const windowHeight = window.innerHeight;
    const scrollableHeight = postContentEnd.offsetTop - windowHeight;
    const scrollTop = window.scrollY;
    const scrollPercentage = (scrollTop / scrollableHeight) * 100;
    const windowWidth = window.innerWidth;
    progress.style.width = `${Math.min((scrollPercentage * windowWidth) / 100, windowWidth)}px`;
  };

  onScroll();

  window.addEventListener('scroll', onScroll);
}
